<template>
  <NuxtImg
    v-if="images.length == 1"
    :src="images[0]"
    :placeholder="placeholderImageUrl"
    draggable="false"
    class="w-full pointer-events-none rounded-lg border-[2px] border-[#F7F7F7]"
    data-testid="carousel-one-image"
  />
  <div v-if="images.length > 1 && isCarouselInitialized" class="relative">
    <div id="image-carousel" class="slider">
      <div v-for="(item, index) in images" :key="index">
        <NuxtImg
          :src="item"
          :placeholder="placeholderImageUrl"
          draggable="false"
          class="w-full pointer-events-none"
          data-testid="carousel-multiple-images"
        />
      </div>
    </div>
    <button
      class="custom-prev w-[40px] h-[40px] hover:bg-[rgba(253,230,230,1)] active:bg-[rgba(253,230,230,1)] bg-[rgba(255,255,255,1)] absolute start-4 top-[186px] rounded-full flex justify-center items-center invisible md:visible"
    >
      <Icon
        data-testid="carousel-icon-prev"
        name="si:chevron-left-alt-fill"
        mode="svg"
        class="h-5 w-5 text-[rgba(235,51,51,1)]"
      />
    </button>
    <button
      class="custom-next w-[40px] h-[40px] hover:bg-[rgba(253,230,230,1)] active:bg-[rgba(253,230,230,1)] bg-[rgba(255,255,255,1)] absolute end-4 top-[186px] rounded-full flex justify-center items-center invisible md:visible"
    >
      <Icon
        data-testid="carousel-icon-next"
        name="si:chevron-right-alt-fill"
        mode="svg"
        class="h-[20px] w-[20px] text-[rgba(235,51,51,1)]"
      />
    </button>
  </div>
</template>

<script setup lang="ts">
import placeholderImageUrl from "@/assets/images/placeholder-content-image.png";
const isCarouselInitialized = ref<boolean>(false);

defineProps({
  images: {
    type: Array as () => string[],
    required: true,
  },
});

onMounted(() => {
  isCarouselInitialized.value = true;

  nextTick(() => {
    const slider = $(".slider");
    slider.slick({
      dots: true,
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: true,
      prevArrow: $(".custom-prev"),
      nextArrow: $(".custom-next"),
    });
  });
});
</script>

<style>
@reference "../assets/styles/main.css";

@import "slick-carousel/slick/slick.css";
@import "slick-carousel/slick/slick-theme.css";

#image-carousel .slick-list .slick-track {
  transition-delay: 10ms;
}
#image-carousel .slick-list {
  @apply rounded-lg overflow-hidden border-[2px] border-[#f7f7f7];
}

#image-carousel .slick-dots {
  @apply bottom-[-25px];
}

#image-carousel .slick-dots li button {
  @apply rounded-[4px] h-[6px] w-[6px] p-0 hover:bg-[#F59999] active:bg-[#F59999] bg-[#e6e6e6];
}

#image-carousel .slick-dots li {
  @apply w-0 h-0;
}

#image-carousel .slick-dots li button:before {
  @apply text-transparent h-[6px] w-[6px];
}

#image-carousel .slick-dots li.slick-active {
  @apply mr-[16px];
}

#image-carousel .slick-dots li.slick-active button {
  @apply bg-[#EB3333] w-[16px];
}

#image-carousel .slick-dots li.slick-active button:before {
  @apply text-transparent;
}

#image-carousel.slick-dotted.slick-slider {
  @apply mb-[38px];
}

#image-carousel .slick-slide > div > div {
  @apply block!;
}
</style>
